import AdvancedSearchView from '@/views/AdvancedSearchView.vue'

const defaultMeta = {
  requiresAuth: true,
  title: 'Advanced Search - Innovation Law Lab Platform',
}

export default {
  path: '/advanced_search',
  name: 'advanced-search',
  meta: defaultMeta,
  component: AdvancedSearchView,
  props: true,
  redirect: { name: 'advanced-search-form' },
  children: [
    {
      path: 'search',
      name: 'advanced-search-form',
      meta: defaultMeta,
      props: true,
      component: _ => import('@/components/Search/Advanced/SearchForm.vue'),
    },
    {
      path: 'search/:uuid',
      name: 'advanced-search-results',
      meta: defaultMeta,
      props: true,
      component: _ => import('@/components/Search/Advanced/SearchForm.vue'),
    },
    {
      path: 'jobs',
      name: 'advanced-search-jobs',
      meta: defaultMeta,
      props: true,
      component: _ => import('@/components/Search/Advanced/SearchJobs.vue'),
    },
  ],
}
